import { render, staticRenderFns } from "./content-add.view.vue?vue&type=template&id=c19dfcb0&"
import script from "./content-add.view.vue?vue&type=script&lang=ts&"
export * from "./content-add.view.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports